import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import App from './App.vue'

// Legacy URL support: if filters arrived on the base query string (pre-hash),
// rewrite them into the hash so vue-router can see them. Skip if the hash
// already carries its own query — the user is mid-navigation and that wins.
(function migrateLegacyQuery() {
  const search = window.location.search;
  if (!search || search.length <= 1) return;
  if ((window.location.hash || '').includes('?')) return;

  const newUrl = window.location.pathname + '#/' + search;
  window.history.replaceState(null, '', newUrl);
})();

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/:pathMatch(.*)*', component: { render: () => null } }
  ]
})

const app = createApp(App).use(router)
router.isReady().then(() => app.mount('#app'))
